import { ITymberEcommStore } from '@getgreenline/blaze-ecomm'
import { LocationModels } from '@getgreenline/locations'
import { THEME_COLORS } from '@getgreenline/shared'
import { ReactNode } from 'react'

export enum EcommerceSettingsFields {
  NAME = 'name',
  ONLINE_MENU = 'onlineMenu',
  ONLINE_ORDERING = 'onlineOrdering',
  ACCEPTING_ORDERS = 'acceptingOrders',
  CONFIGURATION = 'configuration',
}

export enum MessageType {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface LocationWithConfig extends LocationModels.LocationContract {
  key: number
  config: ITymberEcommStore | undefined
}

export interface IRetailerToggleMessage {
  type: MessageType
  field: EcommerceSettingsFields
  retailerId: number
  message: ReactNode
}

export interface PolygonData {
  name: string
  coordinates: number[][]
  lineColor: string
  fillColor: string
}

export const DEFAULT_LINE_COLOR = THEME_COLORS.MONO.monodd
export const DEFAULT_FILL_COLOR = THEME_COLORS.MONO.monoee
